module.exports = __webpack_public_path__ + "media/images/dividend/ic_cc_visa-b075b27c2b86d95d086d3cda90a3931f.svg";